/**
 * Created by huangzhangshu on 2018/8/3
 */
import React, {Component} from 'react';
import {connect} from 'dva';
import moment from 'moment';
import styles from './index.less';
import {wrapImage} from '../../utils';
import Login from '../../components/Login';
import LoginForDark from '../../components/LoginForDark';
import LoginForHXYY_ZHYYGLXT from '../../components/LoginForHXYY_ZHYYGLXT';
import LoginForHXYY_KYYZXJFCXXT from '../../components/LoginForHXYY_KYYZXJFCXXT';
import PasswordResetModal from '../../components/PasswordReset/PasswordResetModal';

const LOGIN_TYPE = {
  hxyy_zhyyglxt: LoginForHXYY_ZHYYGLXT,
  hxyy_kyyzxjfcxxt: LoginForHXYY_KYYZXJFCXXT,
}

// 四川大学华西医院-科研与专项经费查询系统
class LoginPageForHXYY_KYYZXJFCXXT extends Component {

  state = {licenseHeight: 0}

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch({type: 'vadpLogin/updateStatus', payload: true});
    dispatch({type: 'vadpLogin/fetchLicense'});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {licenseHeight} = this.state;
    const licenseDOM = document.getElementById('license');
    if (licenseDOM) {
      const clientHeight = licenseDOM.clientHeight;
      // eslint-disable-next-line react/no-did-update-set-state
      if (licenseHeight !== clientHeight) this.setState({licenseHeight: clientHeight});
    }
  }

  getChinese = (strValue) => { // eslint-disable-line
    if (strValue !== null && strValue !== '') {
      const reg = /[\u4e00-\u9fa5]/g;
      return strValue.match(reg).join('');
    }
    return '';
  }

  getMaxLicenseNameLength = () => {
    const {expireLicense = []} = this.props;
    let maxLength = 0;
    let maxCharLength = 0;
    let maxChineseLength = 0;
    for (const {name: {length}, name} of expireLicense) {
      const chineseName = this.getChinese(name);
      if (length > maxLength) {
        maxLength = length;
        maxChineseLength = chineseName.length;
        maxCharLength = length - chineseName.length;
      }
    }
    return {maxChineseLength: maxChineseLength + 2, maxCharLength};
  }


  renderLicense = () => {
    const {licenseHeight} = this.state;
    const {expireLicense = []} = this.props;
    const {maxChineseLength, maxCharLength} = this.getMaxLicenseNameLength();
    const textStyle = {width: (maxChineseLength * 16) + (maxCharLength * 7)};
    // const textStyle = {};
    // eslint-disable-next-line no-mixed-operators
    const licenseStyle = {top: (innerHeight - (innerWidth * 0.235)) / 2 - 80 - licenseHeight};
    if (!expireLicense || expireLicense.length === 0) return null;
    return (
      <div className={styles.license} style={licenseStyle} id="license">
        <span className={styles.licenseTitle}>您有系统模块许可将于近期失效，请及时申请新许可</span>
        <div className={styles.licenseScroll}>
          {expireLicense.map((license) => {
            const {name, date} = license;
            return (
              <span
                className={styles.licenseText}>
                <span
                  className={styles.licenseTextName}
                  style={textStyle}>{name}模块</span>
                <span
                  className={styles.licenseTextDate}>到期日: {moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日')}</span></span>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const {
      loginStatus, loginBackgroundImageLight, loginImageLight, titleCn,
      titleEn, companyLink, companyName, loginLogo, loginBackgroundRightLight,
      loginBackgroundRightDark, loginLogoLight, loading, theme, systemType = 'vadp',
      loginBackgroundImageDark, loginLogoDark, loginImageDark, dispatch, resetVisible,
    } = this.props;
    const loginProps = {
      dispatch,
      loginStatus,
      loading,
    }
    const lightImages = {
      logo: loginLogoLight,
      image: loginImageLight,
      background: loginBackgroundImageLight,
    };
    const darkImages = {
      logo: loginLogoDark,
      image: loginImageDark,
      background: loginBackgroundImageDark,
    };
    const isDark = theme !== 'light';
    const images = !isDark ? lightImages : darkImages;
    const backgroundRight = !isDark ? loginBackgroundRightLight : loginBackgroundRightDark;
    const license = this.renderLicense();
    const RenderLogin = LOGIN_TYPE[systemType] || (isDark ? LoginForDark : Login);
    return (
      <div
        className={styles.vadpLoginForHxyyKyyzxjfcxxt}
        style={{
          background: `#000724 url(${wrapImage(`/static/images/login-background-hxyy-kyyzxjfcxxt.png`)}) top no-repeat`,
          backgroundSize: 'cover',
        }}>
        <div className={styles.bottom}>
          <span className={styles.company}>Copyright ©2020 Hit All Rights Reserved 版权所有@华西医院</span>
        </div>
        {license}
        <RenderLogin {...loginProps}/>
        <PasswordResetModal visible={resetVisible}  {...this.props} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.vadpLogin.loginStatus,
    loading: state.vadpLogin.loading,
    loginBackgroundImageLight: state.vadpLogin.loginBackgroundImageLight,
    loginLogoLight: state.vadpLogin.loginLogoLight,
    loginImageLight: state.vadpLogin.loginImageLight,
    loginBackgroundImageDark: state.vadpLogin.loginBackgroundImageDark,
    loginLogoDark: state.vadpLogin.loginLogoDark,
    loginImageDark: state.vadpLogin.loginImageDark,
    loginBackgroundRightLight: state.vadpLogin.loginBackgroundRightLight,
    loginBackgroundRightDark: state.vadpLogin.loginBackgroundRightDark,
    titleCn: state.vadpLogin.titleCn,
    titleEn: state.vadpLogin.titleEn,
    companyLink: state.vadpLogin.companyLink,
    companyName: state.vadpLogin.companyName,
    theme: state.vadpLogin.theme,
    loginLogo: state.vadpLogin.loginLogo,
    expireLicense: state.vadpLogin.expireLicense,
    systemType: state.vadpLogin.systemType,
    resetVisible: state.resetPassword.resetVisible,
  };
}

export default connect(mapStateToProps)(LoginPageForHXYY_KYYZXJFCXXT);



// WEBPACK FOOTER //
// ./src/routes/LoginPageForHXYY_KYYZXJFCXXT/index.js